import { PUBLIC_IDM_API_URL_ENV } from 'tools/environments';
import { GetSigninResponse } from './types';

export const getSignin = async ( lang = 'en') => {
	const search = window.location.search;
	const queryParams = [`culture=${lang}`];
	if (search) queryParams.push(search.slice(1));

	return fetch(`${PUBLIC_IDM_API_URL_ENV}/signin?${queryParams.join('&')}`, {
		method: 'GET',
		credentials: 'include',
	})
	.then((res) => {
		if (res.ok) return res.json() as Promise<GetSigninResponse>;
	})
	.catch((error) => {
		console.error('Profile request error: ', error);
		throw error;
	});
};
